import { useState, useEffect, useMemo } from "react";
import { usePermissions } from "../context/Permissioncontext";
import { readUserFromStorage } from "../utils/planningAccess";
import { readActiveHomeRole } from "../utils/homeRole";
import {
  isCoachViewForTraining,
  resolveViewerPlayerId,
  isViewerPresentInSession,
} from "../utils/trainingRoomAccess";

/**
 * Training-room role gate (respects Home `home_active_role` picker).
 */
export function useTrainingRoomAccess(sessionRosterRows = []) {
  const { permissions } = usePermissions();
  const [sessionUser, setSessionUser] = useState(readUserFromStorage);
  const [homeRoleTick, setHomeRoleTick] = useState(0);

  useEffect(() => {
    setSessionUser(readUserFromStorage());
  }, [permissions]);

  useEffect(() => {
    const sync = () => {
      setSessionUser(readUserFromStorage());
      setHomeRoleTick((n) => n + 1);
    };
    window.addEventListener("smarttt-user-updated", sync);
    window.addEventListener("storage", sync);
    window.addEventListener("smarttt-home-role-changed", sync);
    return () => {
      window.removeEventListener("smarttt-user-updated", sync);
      window.removeEventListener("storage", sync);
      window.removeEventListener("smarttt-home-role-changed", sync);
    };
  }, []);

  const activeHomeRole = useMemo(
    () => readActiveHomeRole(sessionUser),
    [sessionUser, homeRoleTick]
  );

  const isCoachView = useMemo(
    () => isCoachViewForTraining(sessionUser, permissions),
    [sessionUser, permissions, homeRoleTick]
  );

  const viewerPlayerId = useMemo(
    () => resolveViewerPlayerId(sessionUser, sessionRosterRows),
    [sessionUser, sessionRosterRows]
  );

  const isPresent = useMemo(
    () => isViewerPresentInSession(viewerPlayerId, sessionRosterRows),
    [viewerPlayerId, sessionRosterRows]
  );

  return {
    sessionUser,
    activeHomeRole,
    isCoachView,
    viewerPlayerId,
    isPresent,
  };
}
